"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwLabel = _interopRequireDefault(require("../cwlabel/CwLabel"));

var _CwImage = _interopRequireDefault(require("../cwimage/CwImage"));

var _CwDashboardFlyout = _interopRequireDefault(require("./CwDashboardFlyout.scss"));

var CwDashboardFlyout = function CwDashboardFlyout(props) {
  return _react.default.createElement("div", {
    "data-cwid": props.cwId,
    className: (0, _classnames.default)(_CwDashboardFlyout.default.flyout, (0, _defineProperty2.default)({}, _CwDashboardFlyout.default.shown, props.isShown))
  }, _react.default.createElement("div", {
    "data-cwid": "".concat(props.cwId, "_background"),
    className: _CwDashboardFlyout.default.flyoutBg,
    onClick: props.onCloseFlyout
  }), _react.default.createElement(_CwImage.default, {
    cwId: "".concat(props.cwId, "_button_close"),
    className: _CwDashboardFlyout.default.closeIcon,
    src: props.closeIcon,
    onClick: props.onCloseFlyout
  }), _react.default.createElement("div", {
    className: _CwDashboardFlyout.default.flyoutContent
  }, _react.default.createElement("div", {
    className: _CwDashboardFlyout.default.flyoutHeader
  }, _react.default.createElement(_CwLabel.default, {
    cwId: "".concat(props.cwId, "_title"),
    className: _CwDashboardFlyout.default.flyoutTitle,
    value: props.title
  })), props.flyoutSrc.length > 0 && _react.default.createElement("iframe", {
    title: 'flyout_iframe',
    "data-cwid": "".concat(props.cwId, "_iframe"),
    className: _CwDashboardFlyout.default.iFrame,
    src: props.flyoutSrc
  })));
};

CwDashboardFlyout.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string.isRequired,

  /**
   * Icon used for the X to close the flyout
   */
  closeIcon: _propTypes.default.string.isRequired,

  /**
   * The src of the iframe displayed in the flyout
   */
  flyoutSrc: _propTypes.default.string.isRequired,

  /**
   * Determines if the flyout is shown or not
   */
  isShown: _propTypes.default.bool.isRequired,

  /**
   * Title displayed at the top of the flyout
   */
  title: _propTypes.default.string.isRequired,

  /**
   * Callback fired when the user clicks the X button or background of the flyout
   */
  onCloseFlyout: _propTypes.default.func.isRequired
};
var _default = CwDashboardFlyout;
exports.default = _default;